import { VoucherStatus } from '../../model/voucher.types';
import { useTranslation } from 'react-i18next';

export const useVoucherLabelTranslations = () => {
    const { t } = useTranslation();

    const getVoucherStatusAsString = (status: VoucherStatus) => {
        return t(`voucherStatus.${status}`, { defaultValue: status });
    };

    return {
        getVoucherStatusAsString,
    };
};
